const sources = {
	internetSearch: 1,
	mediaPortals: 2,
	byRecommendation: 3,
	advertising: 4,
	conferences: 5,
	offersCatalog: 6,
	telegramChats: 7,
	other: 0
};

const locale = {
	ru: {
		internetSearch: 'Поиск в интернете',
		mediaPortals: 'Медиа порталы',
		byRecommendation: 'По рекомендации',
		advertising: 'Реклама',
		conferences: 'Конференции',
		offersCatalog: 'Каталог офферов',
		telegramChats: 'Телеграм чаты',
		other: 'Другое'
	},
	uk: {
		internetSearch: 'Поиск в интернете',
		mediaPortals: 'Медиа порталы',
		byRecommendation: 'По рекомендации',
		advertising: 'Реклама',
		conferences: 'Конференции',
		offersCatalog: 'Каталог офферов',
		telegramChats: 'Телеграм чаты',
		other: 'Другое'
	},
	en: {
		internetSearch: 'Internet search',
		mediaPortals: 'Media portals',
		byRecommendation: 'By recommendation',
		advertising: 'Advertising',
		conferences: 'Conferences',
		offersCatalog: 'Offers catalog',
		telegramChats: 'Telegram chats',
		other: 'Other'
	},
	de: sources,
	vi: sources,
	th: sources
};

module.exports = {
	enum: sources,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/affiliate-registration-sources.js